"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.SearchHeader = exports.SearchHeaderTitle = exports.SearchHeaderNotice = exports.SearchHeaderCount = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var SimpleSearchComponent = function SimpleSearchComponent(componentClassName) {
  return function (_ref) {
    var className = _ref.className,
        children = _ref.children,
        props = (0, _objectWithoutProperties2["default"])(_ref, ["className", "children"]);
    return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
      className: (0, _classnames["default"])("cloud-ui-search-".concat(componentClassName), className)
    }, props), children);
  };
};

var SearchHeaderCount = SimpleSearchComponent('count');
exports.SearchHeaderCount = SearchHeaderCount;
var SearchHeaderNotice = SimpleSearchComponent('notice');
exports.SearchHeaderNotice = SearchHeaderNotice;
var SearchHeaderTitle = SimpleSearchComponent('title');
exports.SearchHeaderTitle = SearchHeaderTitle;

var SearchHeader = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchHeader, _React$Component);

  var _super = _createSuper(SearchHeader);

  function SearchHeader() {
    (0, _classCallCheck2["default"])(this, SearchHeader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SearchHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          count = _this$props.count,
          notice = _this$props.notice,
          children = _this$props.children,
          className = _this$props.className,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["title", "count", "notice", "children", "className"]);
      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        className: (0, _classnames["default"])('cloud-ui-search-header', className)
      }, props), title && /*#__PURE__*/_react["default"].createElement(SearchHeaderTitle, null, title, count > 0 && /*#__PURE__*/_react["default"].createElement(SearchHeaderCount, null, " (", count, ")")), notice && /*#__PURE__*/_react["default"].createElement(SearchHeaderNotice, null, notice), children);
    }
  }]);
  return SearchHeader;
}(_react["default"].Component);

exports.SearchHeader = SearchHeader;
(0, _defineProperty2["default"])(SearchHeader, "propTypes", {
  className: _propTypes["default"].string,
  count: _propTypes["default"].number,
  notice: _propTypes["default"].string,
  title: _propTypes["default"].string
});
(0, _defineProperty2["default"])(SearchHeader, "Count", SearchHeaderCount);
(0, _defineProperty2["default"])(SearchHeader, "Notice", SearchHeaderNotice);
(0, _defineProperty2["default"])(SearchHeader, "Title", SearchHeaderTitle);
var _default = SearchHeader;
exports["default"] = _default;